import { InvoiceDto } from "../../invoice/models"
import { OrderDto } from "../../order/Order"
import { QuoteDto } from "../../quote/Quote"
import { TaxDto } from "../../tax/Tax"
import Preference from "../../user/Preference"
import PreferenceService from "../../user/PreferenceService"
import Group, { GroupDto } from "../Group"
import { PricingFeeCalculationDto } from "../PricingFeeCalculation"
import PricingRow, { PricingRowDto } from "../PricingRow"
import { default as PricingTableClass } from "../PricingTable"
import PricingTableGroupService from "../PricingTableGroupService"
import PricingTableRowService from "../PricingTableRowService"
import { PricingTotalDto } from "../PricingTotals"
import { PricingTable } from "../models"
import { PatchRowPayload } from "../row/services"
import {
    CreateGroupPayload,
    PatchDocumentType,
    PatchPayload,
    RowReferencePayload
} from "../services"
import Service from "../services/service"
import { ACTION_TYPES } from "./types"

export function setInitialState() {
    return {
        type: ACTION_TYPES.SET_INITIAL_VALUES,
    }
}

export const updatePricingTableItems = (items: PricingRowDto[], objectId: string) => {
    return {
        type: ACTION_TYPES.SET_PRICING_TABLE_ITEMS,
        payload: {
            pricingTableObjectId: objectId,
            pricingTableItems: items
        }
    }
}

export const bulkUpdatePricingTable = (objectId: string, payload: object) => {
    return {
        type: ACTION_TYPES.BULK_PATCH_PRICING_TABLE,
        payload: {
            tableId: objectId,
            payload
        }
    
    }
}

export function updatePricingTableGroups(groups: GroupDto[], objectId: string) {
    return {
        type: ACTION_TYPES.SET_PRICING_TABLE_GROUPS,
        payload: {
            pricingTableObjectId: objectId,
            pricingTableGroups: groups,
        }
    }
}

export function updatePricingTableGroupsItems(groupItems: string[], groupId: string, objectId: string) {
    return {
        type: ACTION_TYPES.SET_PRICING_TABLE_GROUP_ITEMS,
        payload: {
            objectId: objectId,
            groupId: groupId,
            groupItems: groupItems
        }
    }
}

export function updatePricingTableTotals(totals: PricingTotalDto[], objectId: string) {
    return {
        type: ACTION_TYPES.SET_PRICING_TABLE_TOTALS,
        payload: {
            objectId: objectId,
            totals: totals,
        }
    }
}

export function updateBottomPriceEnabledAction(isBottomPriceEnabled: boolean) {
    return {
        type: ACTION_TYPES.PRICING_TABLE_BOTTOM_PRICE_ENABLED,
        payload: {
            isBottomPriceEnabled: isBottomPriceEnabled,
        }
    }
}

export function setBottomPriceEnabled(userId: string, isBottomPriceEnabled: boolean) {
    return async (dispatch) => {
        const item = await PreferenceService.UpdateUserPreference({
            bottomPriceEnabled: isBottomPriceEnabled
        }, userId)
        if (item instanceof Preference) {
            dispatch(updateBottomPriceEnabledAction(item.isBottomPriceEnabled()))
        }
    }
}

export function updateIsWorkflowLoadingAction(isWorkflowLoading: boolean) {
    return {
        type: ACTION_TYPES.IS_WORKFLOW_LOADING,
        payload: isWorkflowLoading
    }
}

export function setIsWorkflowLoadingAction(isWorkflowLoading: boolean) {
    return async (dispatch) => {
        dispatch(updateIsWorkflowLoadingAction(isWorkflowLoading))
    }
}

export function updatePricingTableTaxes(totals: PricingTotalDto[], objectId: string) {
    const taxesMap = new Map<string, TaxDto>()
    totals.map(total => {
        if (total.attributes.billingMethod && total.attributes.tax) {
            taxesMap.set(total.attributes.billingMethod, total.attributes.tax)
        }
    })
    return {
        type: ACTION_TYPES.SET_PRICING_TABLE_TAXES,
        payload: {
            objectId: objectId,
            taxes: taxesMap,
        }
    }
}

export function updatePricingTableFees(totals: PricingTotalDto[], objectId: string) {
    let fees: PricingFeeCalculationDto[] | null = null
    if ((totals && totals.length > 0 && totals[0].attributes.feeCalculations.length > 0)) {
        fees = totals[0].attributes.feeCalculations
    }
    return {
        type: ACTION_TYPES.SET_PRICING_TABLE_FEES,
        payload: {
            objectId: objectId,
            fees: fees,
        }
    }
}

export function deletePricingTableItemSuccess(itemId: string, item: PricingRow, objectId: string) {
    return {
        type: ACTION_TYPES.DELETE_PRICING_TABLE_ITEM_SUCCESS,
        payload: {
            itemId: itemId,
            item: item,
            objectId: objectId
        }
    }
}

export function setPricingTableItem(itemId: string, item: PricingRowDto, objectId: string) {
    return {
        type : ACTION_TYPES.SET_PRICING_TABLE_ITEM,
        payload: {
            itemId: itemId,
            item: item,
            objectId: objectId
        }
    }
}

export function addPricingTableSelectedItem(item: string, objectId: string) {
    return {
        type: ACTION_TYPES.PRICING_TABLE_SELECTED_ITEMS_ADD_ITEM,
        payload: {
            item: item,
            objectId: objectId
        }
    }
}

export function setPricingTableSelectedItems(items: Set<string>, objectId: string) {
    return {
        type: ACTION_TYPES.PRICING_TABLE_SET_SELECTED_ITEMS,
        payload: {
            items: items,
            objectId: objectId
        }
    }
}

export function removePricingTableSelectedItem(item: string, objectId: string) {
    return {
        type: ACTION_TYPES.PRICING_TABLE_SELECTED_ITEMS_REMOVE_ITEM,
        payload: {
            item: item,
            objectId: objectId
        }
    }
}

export function setPricingTableId(pricingTableId: string, objectId: string) {
    return {
        type: ACTION_TYPES.SET_PRICING_TABLE_ID,
        payload: {
            pricingTableId: pricingTableId,
            objectId: objectId
        }
    }
}

export function setPricingTableGroup(groupId: string, group: GroupDto, objectId: string) {
    return {
        type : ACTION_TYPES.SET_PRICING_TABLE_GROUP,
        payload: {
            groupId: groupId,
            group: group,
            objectId: objectId
        }
    }
}

export function deletePricingTableGroupAction(itemId: string, item: GroupDto, objectId: string) {
    //not handled in reducer
    return {
        type: ACTION_TYPES.DELETE_PRICING_TABLE_GROUP,
        payload: {
            groupId: itemId,
            group: item,
            objectId: objectId
        }
    }
}

export const patchPricingTableItem = (
    id:string,
    objectId: string,
    documentType: string,
    itemUpdatePayload : PatchRowPayload,
    updateGroup: boolean,
    updateTotals: boolean
) => {
    return {
        type: ACTION_TYPES.PATCH_PRICING_TABLE_ITEM,
        payload: {
            id : id,
            objectId : objectId,
            documentType : documentType,
            itemUpdatePayload : itemUpdatePayload,
            updateGroup : updateGroup,
            updateTotals : updateTotals
        },
    } 
}

export const patchPricingTableItemSuccess = (
    item : PricingRow,
    id : string,
    objectId : string,
    updateGroup: boolean,
    updateTotals : boolean
) => {
    return {
        type: ACTION_TYPES.PATCH_PRICING_TABLE_ITEM_SUCCESS,
        payload: {
            item : item,
            id : id,
            objectId : objectId,
            updateGroup: updateGroup,
            updateTotals : updateTotals
        },
    } 
}

export function setGetPricingTableItem(id: string, objectId: string, documentType: string) {
    return async (dispatch) => {
        const item = await PricingTableRowService.getItem(id, documentType)
        if (item instanceof PricingRow) {
            dispatch(setPricingTableItem(id, item.getDto(), objectId))
        }
    }
}

export const deletePricingTableItem = (id: string, objectId: string, documentType: string) => {

    return {
        type: ACTION_TYPES.DELETE_PRICING_TABLE_ITEM,
        payload: {
            id : id,
            objectId : objectId,
            documentType : documentType,
        },
    } 
}

export const patchPricingTable = (
    documentType: PatchDocumentType,
    documentId: string,
    payload: PatchPayload
) => {
    return {
        type: ACTION_TYPES.PATCH_PRICING_TABLE,
        payload: {
            documentType: documentType,
            documentId: documentId,
            payload: payload
        },
    }
}

export const patchPricingTableSuccess = (
    res: InvoiceDto | QuoteDto | OrderDto | PricingTable
) => {
    return {
        type: ACTION_TYPES.PATCH_PRICING_TABLE_SUCCESS,
        payload: res
    }
}

export const patchPricingTablePending = (
) => {
    return {
        type: ACTION_TYPES.PATCH_PRICING_TABLE_PENDING,
    }
}

export function deletePricingTableGroup(id: string, objectId: string, documentType: string) {
    return async (dispatch) => {
        const item = await PricingTableGroupService.deleteGroup(id, documentType, objectId)
        if (item instanceof Group) {
            dispatch(deletePricingTableGroupAction(id, item.getDto(), objectId))
        }
    }
}

export function patchPricingTableGroup(id: string,
    objectId: string,
    documentType: string,
    payload: { name: string, description: string, calendarEventIds: string[] | [] }
) {
    return async (dispatch) => {
        const item = await PricingTableGroupService.updateGroup(id, objectId, documentType, payload)
        if (item instanceof Group) {
            dispatch(setPricingTableGroup(id, item.getDto(), objectId))
        }
    }
}

export function putPricingTableItemDiscount(id: string,
    objectId: string,
    documentType: string,
    payload: { discountType: string, discountValue: string, mainObjectId: string }
) {
    return async (dispatch) => {
        const item = await PricingTableRowService.updateItemDiscount(id, documentType, payload)
        if (item instanceof PricingRow) {
            dispatch(setPricingTableItem(id, item.getDto(), objectId))
            if(item.getDto().attributes.groupId){
                const group =new Group(item.getDto().attributes.metadata.group)
                if (group instanceof Group) {
                    dispatch(setPricingTableGroup(item.getDto().attributes.groupId, group.getDto(), objectId))
                }
            }
        }
    }
}

export function setPricingTableItems(
    items: PricingRowDto[],
    objectId: string,
    totals: PricingTotalDto[],
    pricingTableId: string,
) {
    return async (dispatch) => {
        dispatch(updatePricingTableItems(items, objectId))
        if (totals) {
            dispatch(updatePricingTableTotals(totals, objectId))
            dispatch(updatePricingTableTaxes(totals, objectId))
            dispatch(updatePricingTableFees(totals, objectId))
        }
        if (pricingTableId) {
            dispatch(setPricingTableId(pricingTableId, objectId))
        }
    }
}


export function setPricingTableTotals(objectId: string, tableId: string, updateTaxes: boolean, updateFees: boolean) {
    return async (dispatch) => {
        const pricingTable = await Service.get(tableId)
        if (pricingTable instanceof PricingTableClass && pricingTable.getDto().totals) {
            dispatch(updatePricingTableTotals(pricingTable.getDto().totals, objectId))
            if (updateTaxes) {
                dispatch(updatePricingTableTaxes(pricingTable.getDto().totals, objectId))
            }
            if (updateFees) {
                dispatch(updatePricingTableFees(pricingTable.getDto().totals, objectId))
            }
        }
    }
}

export function setPricingTableInitialState() {
    return async (dispatch) => {
        dispatch(setInitialState())
    }
}

export function setPricingTable(object: InvoiceDto | QuoteDto | OrderDto | PricingTable) {
    return {
        type: ACTION_TYPES.SET_PRICING_TABLE,
        payload: object
    }
}

export function setPricingTableGroups(groups: GroupDto[], objectId: string) {
    return async (dispatch) => {
        dispatch(updatePricingTableGroups(groups, objectId))
    }
}

export function setPricingTableGroupItems(groups: GroupDto[], items: PricingRowDto[], objectId: string) {
    return async (dispatch) => {
        groups.map(group => {
            const groupItems = items.filter(item => item.attributes.groupId === group.id).map(item => item.id)
            dispatch(updatePricingTableGroupsItems(groupItems, group.id, objectId))
        })
    }
}

export function createGroup(payload: CreateGroupPayload) {
    return {
        type: ACTION_TYPES.CREATE_GROUP,
        payload: payload
    }
}

export function addMultiItemsFromReference(payload: Array<RowReferencePayload>) {
    return {
        type: ACTION_TYPES.ADD_MULTI_ITEMS_FROM_REFERENCE,
        payload: payload
    }
}


// WEBPACK FOOTER //
// ./src/state/pricing/actions/actions.ts